import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslations } from 'next-intl';
import Router from 'next/router';

import { navReset } from '../../../redux/actions/navigation';
import { searchIsOpenToggle, searchReset } from '../../../redux/actions/search';

import { StyledSearchButton } from './searchBar.style';

import CloseIcon from '../../icons/close.svg';
import SearchIcon from '../../icons/search.svg';
import { accessibilityReset } from '../../../redux/actions/accessibility';

const SearchButton = props => {
  const {
    inverted = false,
    close,
    accessibilityIsOpen,
    searchIsOpen,
    navIsOpen,
    handleOpen,
    resetSearch
  } = props;
  const t = useTranslations();

  useEffect(() => {
    Router.events.on('beforeHistoryChange', resetSearch);

    return () => {
      Router.events.off('beforeHistoryChange', resetSearch);
    };
  });

  const Icon = close ? CloseIcon : SearchIcon;
  return (
    <StyledSearchButton
      type="button"
      title={searchIsOpen ? t('search.close') : t('search.open')}
      aria-haspopup="menu"
      aria-expanded={searchIsOpen ? 'true' : 'false'}
      onClick={() => handleOpen(accessibilityIsOpen, navIsOpen)}
      {...props}
      inverted={inverted}
      close={close}
    >
      <Icon aria-hidden="true" />
      <span className="sr-only">{searchIsOpen ? t('search.close') : t('search.open')}</span>
    </StyledSearchButton>
  );
};

SearchButton.propTypes = {
  inverted: PropTypes.bool,
  close: PropTypes.bool,
  searchIsOpen: PropTypes.bool.isRequired,
  accessibilityIsOpen: PropTypes.bool.isRequired,
  navIsOpen: PropTypes.bool.isRequired,
  handleOpen: PropTypes.func.isRequired,
  resetSearch: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  searchIsOpen: state.search.isOpen,
  navIsOpen: state.navigation.isOpen,
  accessibilityIsOpen: state.accessibility.isOpen
});

const mapDispatchToProps = dispatch => ({
  handleOpen: (accessibilityIsOpen, navIsOpen) => {
    dispatch(searchIsOpenToggle());
    if (navIsOpen) {
      dispatch(navReset());
    }

    if (accessibilityIsOpen) {
      dispatch(accessibilityReset());
    }
  },
  resetSearch: () => dispatch(searchReset())
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchButton);
